//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DateField from '../../components/Field/DateField.vue'

export default {
  components: {
    DateField
  },
  props: {
    period: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      periodLocal: {
        employmentDate: null,
        resignationDate: null
      },
      loading: false
    }
  },
  watch: {
    period: {
      handler (val) {
        this.periodLocal = { ...val }
      },
      immediate: true
    }
  },
  methods: {
    onSave () {
      if (this.$refs.employmentDate.validate()) {
        this.loading = true
        this.periodLocal.editTime = Date.now()
        this.periodLocal.user = this.$store.getters.getUser.name
        this.$emit('save', this.periodLocal)
      }
    }
  }
}
